import { render, staticRenderFns } from "./anlitable.vue?vue&type=template&id=486d56ea&scoped=true"
import script from "./anlitable.vue?vue&type=script&lang=js"
export * from "./anlitable.vue?vue&type=script&lang=js"
import style0 from "./anlitable.vue?vue&type=style&index=0&id=486d56ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486d56ea",
  null
  
)

export default component.exports